import { useTranslation } from 'react-i18next';

import RemovableChip from '@/components/atoms/RemovableChip';

interface FilterChipProps {
    label: string;
    /** Null when the label says it all, as "Hiding audit log views" does. */
    value: string | null;
    onRemove: () => void;
    /** Receives the remove button, so the row can move focus when a chip goes. */
    removeRef?: (button: HTMLButtonElement | null) => void;
}

/** One active filter: "Label: value", or the label alone for a flag. */
export default function FilterChip({ label, value, onRemove, removeRef }: FilterChipProps) {
    const { t } = useTranslation();

    if (value === null) {
        return (
            <RemovableChip
                removeLabel={t('auditLog.chips.removeFlag', { label })}
                onRemove={onRemove}
                removeRef={removeRef}>
                {label}
            </RemovableChip>
        );
    }

    return (
        <RemovableChip
            prefix={t('auditLog.chips.labelPrefix', { label })}
            removeLabel={t('auditLog.chips.remove', { label, value })}
            onRemove={onRemove}
            removeRef={removeRef}>
            {value}
        </RemovableChip>
    );
}
